import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { ThemeService } from './services/theme.service';

@Component({
   selector: 'kcms-root',
   imports: [RouterOutlet],
   templateUrl: './app.html',
})
export class App {
   constructor(authService: AuthService, _theme: ThemeService) {
      authService.restoreSession().pipe(take(1)).subscribe();
   }
}
